import "./Heatmap.scss";

const DAYS = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"];
// rampa sequencial azul (references/palette.md do skill dataviz), 100 -> 700
const BLUE_RAMP = [
  "#f0f6fd", // vazio / 0
  "#cde2fb",
  "#9ec5f4",
  "#6da7ec",
  "#3987e5",
  "#256abf",
  "#184f95",
  "#0d366b",
];

function colorFor(value, max) {
  if (!value || max === 0) return BLUE_RAMP[0];
  const ratio = value / max;
  const idx = Math.min(BLUE_RAMP.length - 1, Math.ceil(ratio * (BLUE_RAMP.length - 1)));
  return BLUE_RAMP[Math.max(1, idx)];
}

// grade dia-da-semana x hora, cor = intensidade sequencial (azul, mais escuro = mais conversas)
export default function Heatmap({ grid }) {
  const max = grid.reduce((m, row) => Math.max(m, ...row), 0);

  return (
    <div className="ui-heatmap">
      <div className="ui-heatmap-hours">
        {[0, 3, 6, 9, 12, 15, 18, 21].map((h) => (
          <span key={h} style={{ gridColumnStart: h + 2 }}>
            {h}h
          </span>
        ))}
      </div>
      <div className="ui-heatmap-grid">
        {DAYS.map((day, dayIdx) => (
          <div className="ui-heatmap-row" key={day}>
            <span className="ui-heatmap-day">{day}</span>
            {grid[dayIdx].map((value, hour) => (
              <div
                key={hour}
                className="ui-heatmap-cell"
                style={{ background: colorFor(value, max) }}
                tabIndex={0}
                aria-label={`${day} ${hour}h: ${value} conversas`}
              >
                <span className="ui-heatmap-tooltip">
                  {day} {hour}h — <strong>{value}</strong>
                </span>
              </div>
            ))}
          </div>
        ))}
      </div>
      <div className="ui-heatmap-legend">
        <span>Poucas conversas</span>
        <div className="ui-heatmap-legend-scale">
          {BLUE_RAMP.map((color) => (
            <span key={color} style={{ background: color }} />
          ))}
        </div>
        <span>Muitas conversas</span>
      </div>
    </div>
  );
}
